module.exports = __webpack_public_path__ + "img/21.77e7acc3.png";